@if ((periodCloseComponent.loading$ | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}

@if ((periodCloseComponent.loading$ | async) === false) {
  <div class="px-7 py-7">
    @if (showAnalyticsSection$ | async) {
      <div>
        <div class="mb-8 grid grid-cols-3 gap-7.5">
          <div class="grid h-28 grid-cols-12 rounded border p-4">
            <div class="col-span-6 flex flex-col justify-center border-r">
              <div class="font-bold leading-5">
                In-month
                <br />
                Overrides
              </div>
              <div class="text-xs">% of Total WP</div>
              <div class="text-xs">Overrides $</div>
            </div>
            <div
              class="col-span-6 flex items-center justify-center pl-5 text-lg font-bold tabular-nums"
            >
              <div>
                <div>12%</div>
                <div>$300,000</div>
              </div>
            </div>
          </div>
          <div class="grid h-28 grid-cols-12 rounded border p-4">
            <div class="col-span-6 flex flex-col justify-center border-r">
              <div class="font-bold leading-5">
                Avg. Delta to
                <br />
                Vendor Contract Fcts
              </div>
              <div class="text-xs">% of Total WP</div>
              <div class="text-xs">Average $</div>
            </div>
            <div
              class="col-span-6 flex items-center justify-center pl-5 text-lg font-bold tabular-nums"
            >
              <div>
                <div>24%</div>
                <div>$600,000</div>
              </div>
            </div>
          </div>

          <div class="grid h-28 grid-cols-12 rounded border p-4">
            <div class="col-span-6 flex flex-col justify-center border-r">
              <div class="font-bold leading-5">
                Accrual vs.
                <br />
                Previous Qtr
              </div>
              <div class="text-xs">% Increase</div>
              <div class="text-xs">Increase $</div>
            </div>
            <div
              class="col-span-6 flex items-center justify-center pl-5 text-lg font-bold tabular-nums"
            >
              <div>
                <div>8%</div>
                <div>$82,000</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (gridOptions$ | async; as go) {
      <div style="width: 100%; overflow: auto">
        <div class="flex items-center justify-end gap-5 pb-4 pr-1 pt-1">
          <div class="flex items-center">
            <div class="mr-2 text-sm">Vendor Contract</div>
            <aux-vendor-dropdown
              [showAllOption]="true"
              [vendors]="(organizationQuery.allVendors$ | async)!"
              [formControl]="selectedVendor"
              (onChange)="onVendorSelected($event)"
            />
          </div>

          <aux-export-excel-button
            [gridAPI]="gridAPI"
            [excelOptions]="excelOptions"
            [ignoreColsId]="['vendor_id']"
            [customColFilter]="customColFilter"
            [getDynamicExcelParamsCallback]="getDynamicExcelParams"
            pendoTag="reconciliation-excel-export-button"
          />
        </div>

        <ag-grid-angular
          domLayout="autoHeight"
          class="ag-theme-aux w-full tabular-nums"
          [gridOptions]="go"
          [rowData]="(filteredGridData$ | async)!"
          (firstDataRendered)="onDataRendered($event)"
          (gridReady)="onGridReady($event)"
          (columnResized)="autoSize()"
          auxStickyGrid
        />
      </div>
    }
  </div>
}
